import { useMediaQuery } from 'react-responsive';
export const useResponsive = () => {
    // Screen Setting
    const isLargeDesktop = useMediaQuery({ query: 'screen and (min-width : 1281px)' });
    const isDesktop = useMediaQuery({ query: 'screen and (min-width : 960px)' });
    const isMobile = useMediaQuery({ query: 'screen and (max-width : 959px)' });
    return {
        isLargeDesktop,
        isDesktop,
        isMobile,
    };
};
